import { Link, Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Chat.MultiPayerRequest;

type Props = {
  authorName?: string;
  formattedAmount: string;
  paymentsCount: number;
  /**
   * Inside its own thread the card is the thread's parent: the replies are right below it, so
   * the payments count stays visible but is no longer a link.
   */
  isThreadOpen: boolean;
  onOpenThread: () => void;
};

export const MultiPayerPaymentRequestCardDetails = ({
  authorName,
  formattedAmount,
  paymentsCount,
  isThreadOpen,
  onOpenThread,
}: Props) => {
  const { t } = useResource();
  const paymentsLabel = t(RESOURCES.Payments.Count, { count: paymentsCount });
  const canOpenThread = !isThreadOpen && paymentsCount > 0;

  return (
    <Stack gap={1}>
      {authorName && (
        <Typography variant="subtitle1" fontWeight="bold">
          {authorName}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary">
        {t(RESOURCES.Description)}
      </Typography>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        mt={2}
        mb={1}
      >
        {formattedAmount}
      </Typography>
      {canOpenThread ? (
        <Link
          component="button"
          variant="body1"
          fontSize={14}
          color="text.secondary"
          textAlign="center"
          onClick={onOpenThread}
        >
          {paymentsLabel}
        </Link>
      ) : (
        <Typography fontSize={14} color="text.secondary" textAlign="center">
          {paymentsLabel}
        </Typography>
      )}
    </Stack>
  );
};
